import { useEffect, useState } from 'react'

/**
 * Mostra il tag di versione dell'applicazione nella topbar
 * @param {Object} props
 * @param {string} [props.className] - Classe CSS aggiuntiva
 * @returns {JSX.Element|null}
 */
const VersionInfo = ({ className = '' }) => {
  const [versionData, setVersionData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchVersionInfo = async () => {
      try {
        const response = await fetch('/versioning.json')
        if (response.ok) {
          const data = await response.json()
          setVersionData(data)
        }
      } catch (error) {
        console.warn('Could not fetch version info:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchVersionInfo()
  }, [])

  if (loading || !versionData) {
    return null
  }

  return <span className={`nora-ver ${className}`}>{versionData.tag}</span>
}

export default VersionInfo
